module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    staticClass: "header-booking-data",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.subsidiaries,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.subsidiary),
      callback: function($$v) {
        _vm.subsidiary = $$v
      },
      expression: "subsidiary"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "pa-3 mb-3",
    attrs: {
      "height": "auto"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": "",
      "mb-3": ""
    }
  }, [_c('label', {
    staticClass: "card-title"
  }, [_vm._v("% Empresas Top")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "pl-0": "",
      "mb-2": ""
    }
  }, [_c('v-layout', {
    staticClass: "calendar-range",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "border-right",
    attrs: {
      "md6": "",
      "pa-0": ""
    }
  }, [_c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.menuStart),
      callback: function($$v) {
        _vm.menuStart = $$v
      },
      expression: "menuStart"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Picker in menu",
      "prepend-icon": "event",
      "append-icon": _vm.arrowIconStart,
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateStart),
      callback: function($$v) {
        _vm.dateStart = $$v
      },
      expression: "dateStart"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.dateStart),
      callback: function($$v) {
        _vm.dateStart = $$v
      },
      expression: "dateStart"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "pa-0": ""
    }
  }, [_c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "max-width": "290px"
    },
    model: {
      value: (_vm.menuEnd),
      callback: function($$v) {
        _vm.menuEnd = $$v
      },
      expression: "menuEnd"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Picker in menu",
      "append-icon": _vm.arrowIconEnd,
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.dateEnd),
      callback: function($$v) {
        _vm.dateEnd = $$v
      },
      expression: "dateEnd"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.dateEnd),
      callback: function($$v) {
        _vm.dateEnd = $$v
      },
      expression: "dateEnd"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "mb-2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.categories,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "input": _vm.loadData
    },
    model: {
      value: (_vm.category),
      callback: function($$v) {
        _vm.category = $$v
      },
      expression: "category"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "pl-0": "",
      "mb-2": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "label": "Productos",
      "autocomplete": "",
      "async-loading": _vm.loading,
      "single-line": "",
      "item-text": "productSearching",
      "items": _vm.products,
      "search-input": _vm.search
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "input": _vm.addProducts
    },
    model: {
      value: (_vm.productSelected),
      callback: function($$v) {
        _vm.productSelected = $$v
      },
      expression: "productSelected"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "pl-0": "",
      "mb-4": "",
      "text-xs-left": ""
    }
  }, _vm._l((_vm.productsSelected), function(product, indexProduct) {
    return _c('v-chip', {
      key: product.id,
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          _vm.removeProducts(indexProduct)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(product.productSearching) + "\n\t\t\t\t")])
  })), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('table-run', {
    staticClass: "no-selectable-table",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-export-to-excel": false,
      "include-options": false,
      "include-settings": false,
      "include-search": false,
      "selectable": ""
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.company))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.country))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.percentage))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.total))])]
      }
    }])
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.showChart) ? _c('v-card', {
    staticClass: "pa-3 mb-3",
    attrs: {
      "height": "auto"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "text-xs-left": ""
    }
  }, [_c('label', {
    staticClass: "card-title"
  }, [_vm._v("% Empresa | APK Transportes")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "text-xs-right": ""
    }
  }, [_c('v-layout', {
    staticClass: "search"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Buscar empresa"
    }
  }), _vm._v(" "), _c('v-icon', {
    staticClass: "grey--text"
  }, [_vm._v("search")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "grey--text",
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("insert_drive_file")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "grey--text",
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("print")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, _vm._l((_vm.years), function(year) {
    return _c('v-flex', {
      key: year.name,
      attrs: {
        "xs2": "",
        "pr-3": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs10": "",
        "pr-0": "",
        "text-xs-left": ""
      }
    }, [_c('span', {
      staticClass: "caption-color",
      style: (("background-color: " + (year.color)))
    }), _vm._v(" "), _c('label', {
      staticClass: "caption-text"
    }, [_vm._v(_vm._s(year.name))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-0": "",
        "text-xs-right": ""
      }
    }, [_c('v-checkbox', {
      staticClass: "caption-checkbox"
    })], 1)], 1)], 1)
  }))], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('vue-chart', {
    staticClass: "report-container",
    attrs: {
      "type": "bar",
      "data": _vm.barData,
      "options": _vm.optionsChart
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showChart) ? _c('v-card', {
    staticClass: "pa-3",
    attrs: {
      "height": "auto"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "text-xs-left": ""
    }
  }, [_c('label', {
    staticClass: "card-title"
  }, [_vm._v("% Empresa | APK Transportes")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "text-xs-right": ""
    }
  }, [_c('v-layout', {
    staticClass: "search"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Buscar empresa"
    }
  }), _vm._v(" "), _c('v-icon', {
    staticClass: "grey--text"
  }, [_vm._v("search")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "grey--text",
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("insert_drive_file")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "grey--text",
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("print")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs1": "",
      "mr-3": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select mr3 select-date",
    attrs: {
      "items": _vm.date
    },
    model: {
      value: (_vm.year),
      callback: function($$v) {
        _vm.year = $$v
      },
      expression: "year"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.subsidiaries), function(subsidiary) {
    return _c('v-flex', {
      key: subsidiary.id,
      attrs: {
        "xs2": "",
        "pr-3": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs10": "",
        "pr-0": "",
        "text-xs-left": ""
      }
    }, [_c('span', {
      staticClass: "caption-color",
      style: (("background-color: " + (subsidiary.color)))
    }), _vm._v(" "), _c('label', {
      staticClass: "caption-text"
    }, [_vm._v(_vm._s(subsidiary.name))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "pl-0": "",
        "text-xs-right": ""
      }
    }, [_c('v-checkbox', {
      staticClass: "caption-checkbox",
      model: {
        value: (subsidiary.isSelected),
        callback: function($$v) {
          subsidiary.isSelected = $$v
        },
        expression: "subsidiary.isSelected"
      }
    })], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "pr-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "pr-0": "",
      "text-xs-left": ""
    }
  }, [_c('span', {
    staticClass: "caption-color average"
  }), _vm._v(" "), _c('label', {
    staticClass: "caption-text"
  }, [_vm._v("PROMEDIO")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "pl-0": "",
      "text-xs-right": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "caption-checkbox",
    attrs: {
      "true-value": 1,
      "false-value": 0
    },
    model: {
      value: (_vm.average),
      callback: function($$v) {
        _vm.average = $$v
      },
      expression: "average"
    }
  })], 1)], 1)], 1)], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('vue-chart', {
    staticClass: "report-container",
    attrs: {
      "type": "bar",
      "data": _vm.barData,
      "options": _vm.optionsChart
    }
  })], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76159a1c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/reports/Company.vue
// module id = 1674
// module chunks = 19